import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_VALIDATE_ADDITIONAL_DOCUMENT_FILE_SIZE } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ValidateAdditionalDocumentRequest {
  supportingDocumentsFileUuid?: (string | undefined)[];
  passportPhotoFileUuid?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostValidateAdditionalDocuments = ({ uuid, onSuccess, onError }: Input) => {
  const postValidateAdditionalDocuments = async (reqBody: ValidateAdditionalDocumentRequest) => {
    const res = await axiosClient.post(POST_VALIDATE_ADDITIONAL_DOCUMENT_FILE_SIZE(uuid), reqBody);
    return res.data;
  };

  return useCustomMutation(postValidateAdditionalDocuments, {
    onSuccess,
    onError,
  });
};
